<template>
  <div class="outfit-sharing-button">
    <div class="button-container">
      <div class="button" @click="shareOnClick">
        <div
          class="sharing-text"
          v-if="getButtonTreatment == buttonTreatment.SHARE_TEXT_UPLOAD_ICON"
          v-localize="SHARE_BUTTON_TEXT_KEY"
        ></div>
        <div class="sharing-text" v-localize="OUTFIT_BUTTON_TEXT_KEY" v-else></div>
        <img
          v-if="
            getButtonTreatment == buttonTreatment.SHARE_TEXT_UPLOAD_ICON ||
              getButtonTreatment == buttonTreatment.OUTFIT_TEXT_UPLOAD_ICON
          "
          class="sharing-icon"
          src="@/assets/avbuilder_upload.svg"
          draggable="false"
        />
        <img
          v-if="getButtonTreatment == buttonTreatment.OUTFIT_TEXT_SEND_ICON"
          class="sharing-icon"
          src="@/assets/avbuilder_send.svg"
          draggable="false"
        />
        <img
          v-if="getButtonTreatment == buttonTreatment.OUTFIT_TEXT_BLUE_SEND_ICON"
          class="sharing-icon"
          src="@/assets/avbuilder_bluesend.svg"
          draggable="false"
        />
      </div>
    </div>
    <Spinner v-if="isLoading"></Spinner>
  </div>
</template>

<script>
import FeatureGating from '@/services/FeatureGating';
import ReceiveClientMessage from '@/services/ReceiveClientMessage';
import Spinner from '@/components/ReusableComponents/Spinner';
import { OutfitSharingStateEnum } from '@/enum/outfit_sharing_state';

export default {
  name: 'OutfitSharingButton',
  components: {
    Spinner,
  },
  data: function() {
    return {
      buttonTreatment: {
        CONTROL: 0,
        SHARE_TEXT_UPLOAD_ICON: 1,
        OUTFIT_TEXT_UPLOAD_ICON: 2,
        OUTFIT_TEXT_SEND_ICON: 3,
        OUTFIT_TEXT_BLUE_SEND_ICON: 4,
      },
    };
  },
  created: function() {
    this.SHARE_BUTTON_TEXT_KEY = 'ShareButtonText';
    this.OUTFIT_BUTTON_TEXT_KEY = 'OutfitButtonText';
  },
  methods: {
    shareOnClick: function() {
      this.$store.dispatch('shareOutfit');
    },
    onOutfitSharingMenuLoaded: function(isDeprecated) {
      this.$store.commit('setOutfitSharingState', {
        outfitSharingState: isDeprecated
          ? OutfitSharingStateEnum.OUTFIT_DEPRECATED
          : OutfitSharingStateEnum.NOT_LOADING,
      });
    },
  },
  computed: {
    getButtonTreatment() {
      return FeatureGating.shareOutfitCTAOption();
    },
    isLoading: function() {
      return this.$store.getters.outfitSharingState === OutfitSharingStateEnum.LOADING;
    },
  },
  mounted: function() {
    ReceiveClientMessage.OutfitSharingMenuLoadedEventBus.$on(
      'loaded',
      this.onOutfitSharingMenuLoaded,
    );
  },
  watch: {
    '$store.state.outfitSharingState'(newVal) {
      this.isLoading = newVal;
    },
  },
};
</script>

<style scoped>
.outfit-sharing-button {
  position: absolute;
  /* bottom half of web builder is 52% */
  bottom: 52%;
  right: 0;
  /* visibility is needed to show opacity in iOS */
  visibility: visible;
}

.button-container {
  position: relative;
  bottom: 2px;
}

.button {
  right: 15px;
  height: 35px;
  width: 85px;
  margin-bottom: 5px;
  border-radius: 18px;
  box-shadow: 0 1pt 4pt rgba(0, 0, 0, 0.14);
  background-color: white;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sharing-text {
  font-weight: 700;
  font-size: 13px;
}

.sharing-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 8px;
}

.spinner {
  z-index: 1;
  position: fixed;
  top: 50%;
  left: 50%;
  /* offset by 1/2 of spinner size to center it */
  margin-top: -25px;
  margin-left: -25px;
}

@media (orientation: landscape) {
  .outfit-sharing-button {
    bottom: 0;
  }
}
</style>
